import React from 'react';
import { FormContainer, SectionTitle, SectionSubtitle, GridContainer, FullWidthGrid } from './Styles';
import FormField from './FormField';
import SelectField from './SelectField';

export default function PersonalDetailsStep({ errors, touched, values, setFieldValue }) {
    const handleSelectChange = (fieldName) => (event) => {
        setFieldValue(fieldName, event.target.value);
    };

    // Handle DOB input with auto-formatting
    const handleDobChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); // Remove non-digits

        // Auto-format as DD-MM-YYYY
        if (value.length > 0) {
            if (value.length <= 2) {
                // Just day
                value = value;
            } else if (value.length <= 4) {
                // Day + Month
                value = `${value.slice(0, 2)}-${value.slice(2)}`;
            } else {
                // Day + Month + Year
                value = `${value.slice(0, 2)}-${value.slice(2, 4)}-${value.slice(4, 8)}`;
            }
        }

        setFieldValue('dob', value);
    };

    const genderOptions = [
        { value: 1, label: 'Male' },
        { value: 2, label: 'Female' },
        { value: 3, label: 'Others' },
    ];

    return (
        <FormContainer>
            <SectionTitle>Personal Details</SectionTitle>
            <SectionSubtitle>
                Please provide your personal information. All fields marked with * are required.
            </SectionSubtitle>

            <GridContainer>


                <FormField
                    name="name"
                    label="Full Name"
                    type="text"
                    placeholder="Enter your full name"
                    required
                    error={errors.name}
                    touched={touched.name}
                />

                <FormField
                    name="phone"
                    label="Phone Number"
                    type="tel"
                    placeholder="Enter 10-digit phone number"
                    maxLength="10"
                    required
                    error={errors.phone}
                    touched={touched.phone}
                />
                <FormField
                    name="email"
                    label="Email Address"
                    type="email"
                    placeholder="Enter your email"
                    // required
                    error={errors.email}
                    touched={touched.email}
                />
                <SelectField
                    name="gender"
                    label="Gender"
                    value={values.gender}
                    onChange={handleSelectChange('gender')}
                    options={genderOptions}
                    placeholder="Select Gender"
                    required
                    error={errors.gender}
                    touched={touched.gender}
                />

                <FormField
                    name="dob"
                    label="Date of Birth"
                    type="date"
                    placeholder="DD-MM-YYYY"
                    maxLength="10"
                    required
                    error={errors.dob}
                    touched={touched.dob}
                    value={values.dob} // Pass the value
                    onChange={handleDobChange} // Pass custom onChange
                />

                <FormField
                    name="aadharNumber"
                    label="Aadhar Number"
                    type="tel"
                    placeholder="Enter 12-digit Aadhar number"
                    maxLength="12"
                    required
                    error={errors.aadharNumber}
                    touched={touched.aadharNumber}
                />

                {/* <FormField
                            name="panNumber"
                            label="PAN Number"
                            type="text"
                            placeholder="Enter PAN number (e.g., ABCDE1234F)"
                            error={errors.panNumber}
                            touched={touched.panNumber}
                        /> */}

                <FullWidthGrid>
                    <FormField
                        name="address"
                        label="Address"
                        type="textarea"
                        placeholder="Enter your complete address"
                        rows="3"
                        required
                        error={errors.address}
                        touched={touched.address}
                    />
                </FullWidthGrid>

                {/* <FormField
                    name="city"
                    label="City"
                    type="text"
                    placeholder="Enter your city"
                    required
                    error={errors.city}
                    touched={touched.city}
                />

                <FormField
                    name="pincode"
                    label="Pincode"
                    type="tel"
                    placeholder="Enter 6-digit pincode"
                    maxLength="6"
                    required
                    error={errors.pincode}
                    touched={touched.pincode}
                /> */}
            </GridContainer>
        </FormContainer>
    );
}